/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HealthCampParticipant from './health-camp-participant';
import HealthCampParticipantDetail from './health-camp-participant-detail';
import HealthCampParticipantUpdate from './health-camp-participant-update';
import HealthCampParticipantDeleteDialog from './health-camp-participant-delete-dialog';

const HealthCampParticipantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HealthCampParticipant />} />
    <Route path="new" element={<HealthCampParticipantUpdate />} />
    <Route path=":id">
      <Route index element={<HealthCampParticipantDetail />} />
      <Route path="edit" element={<HealthCampParticipantUpdate />} />
      <Route path="delete" element={<HealthCampParticipantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HealthCampParticipantRoutes;
